import { PreInscricaoAgenda } from '../../../core/api/pre-inscricao.dto';

/**
 * `PRE-15` da igreja-api — sem horário **futuro** com lugar, a campanha recusa toda
 * pré-inscrição. Vale também para campanha sem nenhum horário cadastrado.
 *
 * Horário que já passou não recebe ninguém, então não conta, mesmo com `disponiveis` > 0. A API
 * confere pelo relógio do servidor; aqui é o do navegador, e a diferença só importa nos minutos
 * em volta de um horário.
 */
export function semHorarioComLugar(agendas: PreInscricaoAgenda[]): boolean {
  const agora = Date.now();
  const lugares = agendas
    .filter((a) => !!a.dataHora && new Date(a.dataHora).getTime() > agora)
    .reduce((soma, a) => soma + (a.disponiveis ?? 0), 0);
  return lugares === 0;
}
